<template>
  <div>
        <div class="row">
            <div class="col-12 col-md-6 mt-3">
                <label>Firma*</label>
                <input type="text" v-model.trim="company_name"  @blur="$v.company_name.$touch()" placeholder="Bitte Firma eingeben" :class="{ 'is-invalid': $v.company_name.$error }" class="form-control">
                <div class="invalid-feedback" v-if="!$v.company_name.required">Bitte Firma eingeben</div>
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Straße / Hausnummer*</label>
                <input type="text" v-model.trim="company_address" @blur="$v.company_address.$touch()" placeholder="Bitte Straße / Hausnummer eingeben" :class="{ 'is-invalid': $v.company_address.$error }" class="form-control">
                <div class="invalid-feedback" v-if="!$v.company_address.required">Bitte Straße / Hausnummer eingeben</div>
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>PLZ*</label>
                <input type="text" v-model.trim="post_code" @blur="clearLocations" @input="getPlz" placeholder="Bitte PLZ eingeben" :class="{ 'is-invalid': error_plz }" class="form-control">
                <div class="invalid-feedback" v-if="error_plz">Bitte geben Sie eine gültige PLZ ein.</div>
                <div style="position: relative">
                    <ul class="list-group" v-if="locations">
                        <li class="list-group-item" v-for="loc in locations" :key="loc.id" @click="selectPlz(loc.zip_code, loc.city)">
                            {{loc.zip_code}} {{loc.city}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Ort*</label>
                <input type="text" v-model.trim="city" @blur="$v.city.$touch()" placeholder="Bitte Ort eingeben" :class="{ 'is-invalid': $v.city.$error }" class="form-control">
                <div class="invalid-feedback" v-if="!$v.city.required">Bitte Ort eingeben</div>
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Telefon*</label>
                <input type="text" v-model="company_phone" @blur="$v.company_phone.$touch()" placeholder="Bitte Telefon eingeben" :class="{ 'is-invalid': $v.company_phone.$error }" class="form-control">
                <div class="invalid-feedback" v-if="!$v.company_phone.required">Bitte Telefon eingeben</div>
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Fax</label>
                <input type="text" v-model="company_fax" placeholder="Bitte Fax eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>E-Mail-Adresse*</label>
                <input type="text" v-model="company_email" @focusout="emailToLowercase($event)" @blur="$v.company_email.$touch()" :class="{ 'is-invalid': $v.company_email.$error}" placeholder="Bitte E-Mail-Adresse eingeben" class="form-control lowercase-field">
                <div class="invalid-feedback" v-if="!$v.company_email.email">Bitte eine gültige E-Mail-Adresse eingeben</div>
                <div class="invalid-feedback" v-if="!$v.company_email.required">Bitte E-Mail-Adresse eingeben</div>
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Homepage</label>
                <input type="text" v-model="company_homepage" placeholder="Bitte Homepage eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Geschäftsführer*</label>
                <input type="text" v-model.trim="trade_register_representation" @blur="$v.trade_register_representation.$touch()" placeholder="Bitte Geschäftsführer eingeben"  :class="{ 'is-invalid': $v.trade_register_representation.$error }" class="form-control">
                <div class="invalid-feedback" v-if="!$v.trade_register_representation.required">Bitte Geschäftsführer eingeben</div>
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Handelsregister-Nummer</label>
                <input type="text" v-model="trade_register_number" placeholder="Bitte Handelsregister-Nummer eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Umsatzsteueridentifikationsnummer</label>
                <input type="text" v-model="tax_exchange_number" placeholder="Bitte Umsatzsteueridentifikationsnummer eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Steuernummer</label>
                <input type="text" v-model="tax_number" placeholder="Bitte Steuernummer eingeben" class="form-control">
            </div>
            <div class="col-12 col-md-6 mt-3">
                <label>Sitz der Gesellschaft</label>
                <input type="text" v-model="trade_register_court" placeholder="Bitte Sitz der Gesellschaft eingeben" class="form-control">
            </div>
        </div>
        <div class="mt-3 text-right">
            <button class="btn btn-success"  @click="validateOrtBackEnd(save)">Speichern</button>
        </div>

       <b-toast id="success-toast" variant="success" solid>
            {{success}}
       </b-toast>
       <b-modal ref="error-modal" :title="'Fehlermeldung'">
            <div class="d-block">
                <h5>Bitte füllen Sie die erforderlichen Felder aus</h5>
            </div>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <b-button variant="danger" @click="cancel()">Schließen</b-button>
            </template>
       </b-modal>
    </div>
</template>

<script>
import {email, numeric, required} from 'vuelidate/lib/validators';

    export default {
        data() {
            return {
                success : '',
                impressum: null,
                objects: this.$store.getters.objects,
                company_name: '',
                company_address: '',
                post_code: '',
                city: '',
                company_phone: '',
                company_fax: '',
                company_email: '',
                company_homepage: '',
                trade_register_representation: '',
                trade_register_number: '',
                tax_exchange_number: '',
                tax_number: '',
                trade_register_court: '',
                locations: [],
                error_plz   : false,
            }
        },
        watch: {
            objects : function (val){
              this.objects = val;
            },
            impressum: function(val){
                if(val && Object.keys(val).length > 0){
                    this.company_name = val.company_name;
                    this.company_address = val.company_address;
                    this.post_code = val.post_code;
                    this.city = val.city;
                    this.company_phone = val.company_phone;
                    this.company_fax = val.company_fax;
                    this.company_email = val.company_email ? val.company_email.toLowerCase() : val.company_email;
                    this.company_homepage = val.company_homepage;
                    this.trade_register_representation = val.trade_register_representation;
                    this.trade_register_number = val.trade_register_number;
                    this.tax_exchange_number = val.tax_exchange_number;
                    this.tax_number = val.tax_number;
                    this.trade_register_court = val.trade_register_court;
                }
            }
        },
        methods: {
            emailToLowercase(event) {
              if (!event.target.value.match(/([A-Z])+/)) {
                return;
              }

              let email = event.target.value;
              email = event.target.value.toLowerCase();
              this.company_email = email;
            },
            validateOrtBackEnd(fn) {
                if (this.$v.company_email.$anyError) {
                  return false;
                }

                this.$store.state.loading = true;
                this.error_plz = false;

                this.$http.get(`/objectApi/validateOrt?ort=${this.city}&plz=${this.post_code}`).then(response => {
                }).catch(() => {
                    this.error_plz = true;
                }).then(() => {
                    this.$store.state.loading = false;
                    if(!this.error_plz)
                        fn();
                });
            },
            save (){
                if(this.objects && this.validate()){
                    let object = this.objects[0];
                    object.impressum = {
                        company_name: this.company_name,
                        company_address: this.company_address,
                        post_code: this.post_code,
                        city: this.city,
                        company_phone: this.company_phone,
                        company_fax: this.company_fax,
                        company_email: this.company_email ? this.company_email.toLowerCase() : this.company_email,
                        company_homepage: this.company_homepage,
                        trade_register_representation: this.trade_register_representation,
                        trade_register_number: this.trade_register_number,
                        tax_exchange_number: this.tax_exchange_number,
                        tax_number: this.tax_number,
                        trade_register_court: this.trade_register_court,
                    }
                    this.$store.state.loading = true;

                    this.$http.put('/objectApi/updateObject?id='+object.id+'&updateImpressumOnly=true', object).then(response => {
                        this.$store.state.editObject = object;
                        this.success = response.data;
                        this.$bvToast.show('success-toast');
                        this.$store.state.loading = false;
                        /*setTimeout(() => {
                            this.$router.push({name: 'inserat-uebersicht', params: {page: this.$store.state.lastOpenedPage}});
                        }, 1000);*/
                    }).catch(error => {
                        this.$store.state.loading = false;
                        this.$emit('error', error.response.data.data);
                    });
                }
                else{
                    this.$refs['error-modal'].show();
                }
            },
            validate() {
                if(!this.post_code || !this.city){
                    return false;
                }
                return true;
            },
            getPlz() {
                this.$http.get('/objectApi/getPlz?term='+this.post_code).then((response) => {
                    this.locations = JSON.parse(response.data);
                    if(this.locations) this.error_plz = false;
                });
            },
            selectPlz(plz, city) {
                this.post_code = plz;
                this.city = city;
                this.locations = [];
            },
            clearLocations() {
                this.$v.$touch();
                setTimeout(() => { this.locations = [] }, 500);
            },
        },
        created() {
            this.$store.dispatch('IMPRESSUM');
            this.$store.watch( () => {
                return this.$store.getters.impressum; // could also put a Getter here
                }, (impressum) =>{
                    this.impressum = impressum;
                }
            );
            this.$store.watch(() => {
                return this.$store.getters.objects;
            }, objects => {
                this.objects = objects;
            });
        },
      validations: {
            company_name : {required},
            company_address : {required},
            city : {required},
            company_phone : {required},
            trade_register_representation : {required},
            company_email: {email, required},
            post_code: {numeric, required}
        }
    }
</script>

<style scoped>
.list-group{
    max-height: 400px;
    position: absolute;
    top: 0;
    left: 0;
    overflow: auto;
    width: 300px;
    z-index: 10;
}
.list-group-item{
    cursor: pointer;
}
.lowercase-field {
  text-transform: lowercase;
}
</style>
